import { Navigate } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";
import { Loader2 } from "lucide-react";

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: ('ADMIN' | 'SUPERVISOR' | 'PADRAO' | 'VISUALIZACAO')[];
  redirectTo?: string;
}

/**
 * Componente que protege rotas baseado no papel do usuário.
 * Se o usuário não tem o papel permitido, redireciona para a rota especificada.
 */
export const RoleProtectedRoute = ({
  children,
  allowedRoles = ['ADMIN', 'SUPERVISOR'],
  redirectTo = '/projects'
}: RoleProtectedRouteProps) => {
  const { getCurrentUserProfile, isLoadingPermissions } = usePermissions();

  if (isLoadingPermissions) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  const profile = getCurrentUserProfile();
  const userRole = profile?.role || 'PADRAO';

  if (!allowedRoles.includes(userRole as any)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;
